export enum UserRoles {
  admin = 'admin',
  importer = 'importer',
  productEditor = 'productEditor',
  mediaEditor = 'mediaEditor',
  plcardManager = 'plcardManager',
  plcardViewer = 'plcardViewer',
  pricelistManager = 'pricelistManager',
  pricelistViewer = 'pricelistViewer',
  pricelistCorrectionManager = 'pricelistCorrectionManager',
  brandManager = 'brandManager',
  commercialCatalogue = 'commercialCatalogue'
}

export enum RoleFeatures {
  importDocument = 'importDocument',
  editProduct = 'editProduct',
  editMedia = 'editMedia'
}

export const rolesConfig: Record<RoleFeatures, UserRoles[]> = {
  [RoleFeatures.importDocument]: [UserRoles.importer],
  [RoleFeatures.editProduct]: [UserRoles.productEditor],
  [RoleFeatures.editMedia]: [UserRoles.mediaEditor]
};

export const userRoleMap = {
  user: 'User',
  [UserRoles.admin]: 'Admin',
  [UserRoles.importer]: 'Importer',
  [UserRoles.productEditor]: 'Product editor',
  [UserRoles.mediaEditor]: 'Media editor',
  [UserRoles.plcardViewer]: 'P&L card viewer',
  [UserRoles.plcardManager]: 'P&L card manager',
  [UserRoles.pricelistViewer]: 'Pricelist viewer',
  [UserRoles.pricelistManager]: 'Pricelist manager',
  [UserRoles.pricelistCorrectionManager]: 'Pricelist correction manager',
  [UserRoles.brandManager]: 'Brand manager',
  [UserRoles.commercialCatalogue]: 'Marketing'
};
